module.exports = __webpack_public_path__ + "static/media/vooPosProcessado.eef8eb1c.png";